import React, { useEffect, useRef, useState } from "react";
import "./QuoteOrderConfirmation.css";
import { Tooltip } from "@mui/material";

const QuoteOrderConfirmation = ({quote, parts, vendors, okAction, onClose }) => {
  const propertyRefs = useRef({});
  const [tooltips, setTooltips] = useState({});
  const currentDate = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  useEffect(() => {
    const newTooltips = {};
    Object.entries(propertyRefs.current).forEach(([key, el]) => {
      if (el) {
        newTooltips[key] = el.scrollWidth > el.clientWidth;
      }
    });
    setTooltips(newTooltips);
  }, []);
  return (
    <div className="quote-order-confirmation-container">
      <div className="quote-order-confirmation-header">
        <div className="quote-order-confirmation-title">
          <i className="icon-confirmation"></i>
          <b>Your request for quote was sent to the selected vendors.</b>
        </div>
        <div className="quote-order-confirmation-number">
          <b>Cod RFQ</b>
          <div className="quote-order-confirmation-number-value">
            <b>{quote.id}</b>
          </div>
        </div>
      </div>
      <div className="quote-order-confirmation-company">
        <div className="quote-order-confirmation-company-right">
          <p>Company</p>
          <b>{parts[0].company_name}</b>
        </div>
        <div className="quote-order-confirmation-company-left">
          <p>Date Sent</p>
          <b>{currentDate}</b>
        </div>
      </div>
      <div className="quote-order-confirmation-vendors-title">
        <b>Vendor(s) Selected</b>
      </div>
      <div className="quote-order-confirmation-vendors-list">
        {vendors?.length > 0 ? (
          vendors.map((vendor, index) => (
            <div className="vendor-selected-item" key={index}>
              <div className="title-vendor-selected">
                <i className="icon-check-3"></i>
                <span>{vendor.name}</span>
              </div>
            </div>
          ))
        ) : (
          <div className="no-vendors-selected">
            <p>No vendors selected</p>
          </div>
        )}
      </div>
      <div className="quote-order-prn-info">
        <div className="quote-order-prn-info-title">
          <b>PRN</b>
          <b>PN</b>
          <b>Required</b>
          <b>Location</b>
          <b>Site</b>
          <b>Required Date</b>
        </div>
        <div className="quote-order-prn-info-list">
          {parts.map((part, index) => (
            <React.Fragment key={`${part.id}-${index}`}>
              <div className="item-prn-info-quote-container">
                {[
                  "id",
                  "part_number",
                  "quantity",
                  "pr_location_code",
                  "pr_site_name",
                  "date_request_required",
                ].map((label) => (
                  <div
                    className={`property ${label === "quantity" ? "" : ""}`}
                    key={label}
                  >
                    <Tooltip
                      title={tooltips[`${part.id}-${label}`] ? part[label] : ""}
                      arrow
                    >
                      {label == "quantity" ? (
                        <p
                          className="bold-font-black"
                          ref={(el) => {
                            if (el) {
                              propertyRefs.current[`${part.id}-${label}`] = el;
                            }
                          }}
                        >
                          {part[label] + " " + part["uom_abrevation"]}
                        </p>
                      ) : label == "date_request_required" ? (
                        <p
                          className="bold-font-date"
                          ref={(el) => {
                            if (el) {
                              propertyRefs.current[`${part.id}-${label}`] = el;
                            }
                          }}
                        >
                          {part[label]}
                        </p>
                      ) : (
                        <p
                          className="light-font"
                          ref={(el) => {
                            if (el) {
                              propertyRefs.current[`${part.id}-${label}`] = el;
                            }
                          }}
                        >
                          {part[label]}
                        </p>
                      )}
                    </Tooltip>
                  </div>
                ))}
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
      <button
        onClick={onClose}
        className={`filled iconTextButton greenButton`}
        style={{ width: "10rem" }}
      >
        <span>Ok</span>
      </button>
    </div>
  );
};

export default QuoteOrderConfirmation;
